import { compose } from 'recompose';
import { injectIntl } from 'react-intl';

export const enhance = compose(injectIntl);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/DeviceSetup/enhance.js